import Phaser from 'phaser';
import { COLORS, GAME_WIDTH, GAME_HEIGHT } from '../constants.js';

/**
 * TitleScene - Initial screen with PLAY button
 * This scene exists to get user interaction before MenuScene,
 * which allows audio to play automatically (browser autoplay policy)
 */
export default class TitleScene extends Phaser.Scene {
  constructor() {
    super({ key: 'TitleScene' });
  }

  create() {
    // Dark background
    this.cameras.main.setBackgroundColor('#0a0a0a');

    // Game title with retro styling
    const title = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 100, 'DEAD SECTOR', {
      fontFamily: 'Courier New',
      fontSize: '64px',
      fill: '#ff0000',
      stroke: '#000000',
      strokeThickness: 8,
    });
    title.setOrigin(0.5);

    // Subtitle
    const subtitle = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 40, 'A 1v1 Studios Production', {
      fontFamily: 'Courier New',
      fontSize: '18px',
      fill: '#888888',
    });
    subtitle.setOrigin(0.5);

    // Create PLAY button
    const buttonWidth = 200;
    const buttonHeight = 60;
    const buttonX = GAME_WIDTH / 2;
    const buttonY = GAME_HEIGHT / 2 + 60;

    // Button background
    const button = this.add.rectangle(buttonX, buttonY, buttonWidth, buttonHeight, 0x222222);
    button.setStrokeStyle(3, COLORS.NEON_PINK);
    button.setInteractive({ useHandCursor: true });

    // Button text
    const buttonText = this.add.text(buttonX, buttonY, 'PLAY', {
      fontFamily: 'Courier New',
      fontSize: '32px',
      fill: '#ffffff',
    });
    buttonText.setOrigin(0.5);

    // Button hover effects
    button.on('pointerover', () => {
      button.setFillStyle(0x333333);
      button.setStrokeStyle(3, 0x00ffff);
      buttonText.setFill('#00ffff');
    });

    button.on('pointerout', () => {
      button.setFillStyle(0x222222);
      button.setStrokeStyle(3, COLORS.NEON_PINK);
      buttonText.setFill('#ffffff');
    });

    // Click to start
    button.on('pointerdown', () => this.startGame());

    // Also allow ENTER key
    this.input.keyboard.on('keydown-ENTER', () => this.startGame());

    // Hint text
    this.add.text(GAME_WIDTH / 2, GAME_HEIGHT - 40, 'Press ENTER or click PLAY', {
      fontFamily: 'Courier New',
      fontSize: '14px',
      fill: '#666666',
    }).setOrigin(0.5);

    // VHS effect - scanlines overlay hint
    this.add.text(GAME_WIDTH / 2, GAME_HEIGHT - 20, '1987', {
      fontFamily: 'Courier New',
      fontSize: '12px',
      fill: '#333333',
    }).setOrigin(0.5);
  }

  startGame() {
    // Clean up
    this.input.keyboard.off('keydown-ENTER');

    // Fade to menu
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.start('MenuScene');
    });
  }
}
